import { createFileRoute } from "@tanstack/react-router";
import TalkingAboutTRD from "@/pages/TalkingAboutTRD";
export const Route = createFileRoute(
  "/talking-about-treatment-resistant-depression",
)({
  component: RouteComponent,
  head() {
    return {
      meta: [
        {
          title: "Talking About TRD | Neuro Wellness TMS",
        },
        {
          name: "description",
          content:
            "Practical guidance for families on how to bring up treatment-resistant depression with someone you care about. What to say, what not to say, and when to try.",
        },
        {
          property: "og:title",
          content: "Talking About TRD | Neuro Wellness TMS",
        },
        {
          property: "og:description",
          content:
            "Practical guidance for families on how to bring up treatment-resistant depression with someone you care about. What to say, what not to say, and when to try.",
        },
        {
          property: "og:url",
          content:
            "https://neurowellnesstms.com/talking-about-treatment-resistant-depression",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/talking-about-treatment-resistant-depression",
        },
      ],
    };
  },
});
function RouteComponent() {
  return <TalkingAboutTRD />;
}
